import * as y from 'yup';

export const updateDischargeDateSchema = y.object({
  discharge_date: y.string().nullable(),
});

export type updateDischargeDateDTO = y.InferType<
  typeof updateDischargeDateSchema
>;
